//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
//  -- Features -----------------------
import React, { useEffect, useState } from 'react';
//  -- Constants ----------------------
import { ArrowRightRounded, CheckCircleRounded, ContentCopy } from '@mui/icons-material';
import { Tooltip } from 'antd';
import Loading from 'components/Loading';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { handleListOneWayBingo } from 'store/bingo/thunks';
import { useClassUsers } from 'store/userClasses/selectors';
import PrintLoteria from '../PrintBingo/PrintLoteria';
import GameLoteriaLoaader from './GameLoteriaLoaader';
import PreviewLoteria from './PreviewLoteria';
import CloneLoteriaModal from './CloneLoteriaModal';
import SentryWrap from 'components/Sentry';

const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 1092,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function AdminLoteria({ bookId, pageId, startGame, gameInitLoader, gameType,newMaskId = "" }) {
    const showAlert = useAlert();
    const [games, setGames] = useState([])
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({});
      const classUsers = useClassUsers();
      const classStudentUsers = classUsers?.filter(
        (obj) => obj?.role === "student"
      );
      const [cloneModal, setCloneModal] = useState(false);
      const [cloneGame, setCloneGame] = useState(null);
    const dispatch = useDispatch();
    const loadData = async () => {
        setLoading(true)
        const BingoList = {
            chapter: bookId,
            page: pageId,
            role: 'owe_admin'
        }
        const data = await dispatch(handleListOneWayBingo(BingoList))
        if (data && Array.isArray(data)) {
            setGames(data);
        }
        setLoading(false);
    }

    useEffect(() => {
        loadData();
    }, [pageId, gameType])

    if (isLoading) {
        return (<GameLoteriaLoaader />);
    }

    if (games.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No lotería games available!</div>
        </div>
        )
    }
    const handleOpenCloneModal = (gameData) => {
        setCloneGame(gameData);
        setCloneModal(true);
    };

    return (<SentryWrap>   
        <Slider {...settings}>
            {games.map((item, index) => {
                return (
                    <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                        <div className='draftImage-game frameStyle'>
                            <PreviewLoteria grid={item?.bingo_data} bingoSize={item?.configurations?.bingo_size} selectedType={item?.bingo_type} />
                        </div>
                        <div className='myUnitsTxt'>
                            <div className='myUnitsInfo'>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                                    <Tooltip title={item?.criteria || 'Untitled'} placement="top">
                                        <label
                                            className='text-dark'
                                            style={{
                                                display: 'block',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                maxWidth: '100%',
                                            }}
                                        >
                                            {item?.criteria || 'Untitled'}
                                        </label>
                                    </Tooltip>
                                    <span
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                        onClick={() => handleOpenCloneModal(item)}
                                        className="text-dark"
                                    >
                                        <ContentCopy style={{ fontSize: 18 }} />
                                    </span>
                                </div>
                                 {newMaskId !== "" && (
                                    <span>Pg. {newMaskId || '--'}</span>
                                )}  
                                <span>
                                    Lotería Size: {item?.configurations?.bingo_size
                                        ? `${item.configurations.bingo_size} X ${item.configurations.bingo_size}`
                                        : '--'}
                                </span>
                            </div>
                            <div className='loteriaUnitsBtns'>
                                <PrintLoteria
                                    bingoSize={item?.configurations?.bingo_size}
                                    selectedType={item?.bingo_type}
                                    grid={item?.bingo_data}
                                    classUsers={classStudentUsers}
                                    isGridValid={true}
                                    showSnack={showAlert}
                                 />
                                <a onClick={async () => {
                                    if (gameInitLoader) {
                                        return false;
                                    }
                                    if (item?.bingo_data?.length > 0) {
                                        setSelectedGame(item);
                                        await startGame(item);
                                        setSelectedGame({});
                                    } else {
                                        showAlert("Something went wrong, please try with new lotería", "error");
                                    }
                                }}
                                    className={`loteriaBtnsStart`}>
                                    <ArrowRightRounded />{gameInitLoader && selectedGame.id === item.id ? <Loading size={12} white /> : null} start
                                </a>
                            </div>
                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                        </div>
                    </div>
                )
            })}
        </Slider>
        <CloneLoteriaModal
            open={cloneModal}
            onClose={() => {
                setCloneModal(false);
                setCloneGame(null);
            }}
            cloneGame={cloneGame}
            bookId={bookId}
            pageId={pageId}
            onSuccess={loadData}
        /></SentryWrap>)
}